import RockingChair from "./RockingChair";

export * from "./Armchair";
export * from "./Bed";
export * from "./BedDouble";
export * from "./BedSingle";
export * from "./DoorClosed";
export * from "./DoorOpen";
export * from "./Lamp";
export * from "./LampCeiling";
export * from "./LampDesk";
export * from "./LampFloor";
export * from "./LampWallDown";
export * from "./LampWallUp";
export * from "./RockingChair";

export const Furnit = {
  RockingChair,
};
